var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.25V2.75H21V8.25H13ZM3 11.9167V2.75H11V11.9167H3ZM13 19.25V10.0833H21V19.25H13ZM3 19.25V13.75H11V19.25H3ZM5 10.0833H9V4.58333H5V10.0833ZM15 17.4167H19V11.9167H15V17.4167ZM15 6.41667H19V4.58333H15V6.41667ZM5 17.4167H9V15.5833H5V17.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.75b6cbc61dc0af1d49b8a18a405bd927.svg";
export { ForwardRef as ReactComponent };